export const getShareToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const match = window.location.pathname.match(/^\/share\/([^/]+)/);
  if (match && match[1]) {
    return match[1];
  }

  const params = new window.URLSearchParams(window.location.search);
  const token = params.get('share_token');
  return token || null;
};

export const appendShareToken = (url) => {
  const token = getShareToken();
  if (!token) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}share_token=${encodeURIComponent(token)}`;
};
